import React, { useEffect, useState } from "react";
import "./ContactUs.css";
import axios from "axios";
import { AiOutlineCheckCircle } from "react-icons/ai";
import Nav from "../Home/navbar/nav";
import { Helmet } from "react-helmet";
import IndianFlag from "../Media/indian.png";
import USAFlag from "../Media/american.png";

const ContactUs = () => {
  const locations = [
    {
      id: "india",
      flagSrc: IndianFlag, // place your flag image here
      flagEmoji: "🇮🇳",
      country: "INDIA",
      addressLines: [
        "6/483 C, Fathima Road East,",
        "Azhagappapuram, Kanyakumari District,",
        "Tamil Nadu - 629401.",
      ],
      gmap: "#",
      contacts: [
        { title: "Sales Enquiry", email: "sales@althisolutions.com" },
        { title: "HR Enquiry", email: "hr@althisolutions.com" },
      ],
    },
    // {
    //   id: "usa",
    //   flagSrc: USAFlag,
    //   flagEmoji: "🇺🇸",
    //   country: "USA",
    //   addressLines: ["1200 Ford Rd, Farmers Branch,", "Texas - 75234."],
    //   gmap: "#",
    //   contacts: [
    //     { title: "Sales Enquiry", email: "sales@althisolutions.com" },
    //     { title: "HR Enquiry", email: "hr@althisolutions.com" },
    //   ],
    // },
  ];
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    organization: "",
    region: "",
    message: "",
  });

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const apiURL = process.env.REACT_APP_CONTACTUS_HOST;

    const payload = {
      message: {
        fullName: formData.firstName + " " + formData.lastName,
        email: formData.email,
        organization: formData.organization,
        region: formData.region,
        message: formData.message,
      },
    };

    if (
      formData.firstName &&
      formData.organization &&
      formData.message &&
      formData.email &&
      formData.region
    ) {
      axios
        .post(apiURL, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          setShowSuccessMessage(true);

          setTimeout(() => {
            setShowSuccessMessage(false);
            setFormData({
              firstName: "",
              lastName: "",
              email: "",
              organization: "",
              region: "",
              message: "",
            });
          }, 3000);
        });
    }
  };

  return (
    <>
      <div className="w-full ">
        <Helmet>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <title>Contact Us</title>
          <meta
            name="description"
            content="We're here to help with your next step in digital success."
          />
          <link
            rel="canonical"
            href="https://www.althisolutions.com/contactus"
          />
          <meta name="robots" content="index, follow" />

          <meta property="og:type" content="website" />
          <meta property="og:title" content="Contact Us" />
          <meta
            property="og:url"
            content="https://www.althisolutions.com/contactus"
          />
          <meta
            property="og:image"
            content="https://althisolutions.com/static/media/Contactus-bg.5453882e5eb86b6b57e7.jpg"
          />
          <meta
            property="og:description"
            content="We're here to help with your next step in digital success."
          />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Contact Us" />
          <meta name="twitter:site" content="@Althisolutions" />
          <meta
            name="twitter:description"
            content="We're here to help with your next step in digital success."
          />
          <meta
            name="twitter:image"
            content="https://althisolutions.com/static/media/Contactus-bg.5453882e5eb86b6b57e7.jpg"
          />
        </Helmet>

        <Nav />

        <div className="contactus-section-banner aln_Pos">
          <div className="contact-overlay">
            {/* <div className='container'> */}
            <div
              className="contactus-section-overlay flex"
              style={{ height: "auto", padding: "134px 25px" }}
            >
              <div className="max_Width w-full">
                <div className="contactus-section-banner-content-section">
                  <div className="contactus-section-banner-form">
                    <div className="contactus-form">
                      <h2>Let's Talk</h2>
                      <div className="contact-form-container">
                        <form className="contact-form" onSubmit={handleSubmit}>
                          {/* First + Last Name */}
                          <div className="form-row">
                            <div className="form-group half">
                              <label
                                className="contact-form-label"
                                htmlFor="firstName"
                              >
                                First Name
                              </label>
                              <input
                                type="text"
                                id="firstName"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                required
                              />
                            </div>
                            <div className="form-group half">
                              <label
                                className="contact-form-label"
                                htmlFor="lastName"
                              >
                                Last Name
                              </label>
                              <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          {/* Email */}
                          <div className="form-group">
                            <label
                              className="contact-form-label"
                              htmlFor="email"
                            >
                              Email
                            </label>
                            <input
                              type="email"
                              id="email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          {/* Organization + Region */}
                          <div className="form-row">
                            <div className="form-group half">
                              <label
                                className="contact-form-label"
                                htmlFor="organization"
                              >
                                Organization
                              </label>
                              <input
                                type="text"
                                id="organization"
                                name="organization"
                                value={formData.organization}
                                onChange={handleChange}
                                required
                              />
                            </div>
                            <div className="form-group half">
                              <label
                                className="contact-form-label"
                                htmlFor="region"
                              >
                                Region
                              </label>
                              <input
                                type="text"
                                id="region"
                                name="region"
                                value={formData.region}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>

                          {/* Message */}
                          <div className="form-group">
                            <label
                              className="contact-form-label"
                              htmlFor="message"
                            >
                              How Can We Help You...
                            </label>
                            <input
                              id="message"
                              name="message"
                              value={formData.message}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          {/* Submit */}
                          <div className="form-group submit-group">
                            <button type="submit">Submit</button>
                          </div>
                        </form>
                      </div>
                    </div>
                    {showSuccessMessage && (
                      <div className="success-messages">
                        <div className="success-message-contents">
                          <div className="success-message-headings">
                            Submitted Successfully !
                          </div>
                          <AiOutlineCheckCircle className="check-icon"></AiOutlineCheckCircle>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="contactus-section-banner-content ">
                    <p className="w-full">Request for Service</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="locations-section">
          <div className="container">
            <h2 className="locations-title">Our Locations</h2>
            <p className="locations-sub">
              From questions about pricing to personalized one-on-one demos,
              we’re here to help you get started.
            </p>

            <div className="locations-list">
              {locations.map((loc) => (
                <article className="location-row" key={loc.id}>
                  {/* LEFT SIDE */}
                  <div className="location-left">
                    <div className="flag-and-name">
                      {loc.flagSrc ? (
                        <img
                          src={loc.flagSrc}
                          alt={`${loc.country} flag`}
                          className="flag-image"
                        />
                      ) : (
                        <div className="flag-emoji">{loc.flagEmoji}</div>
                      )}
                      <h3 className="country-name">{loc.country}</h3>
                    </div>

                    <address className="address-block">
                      {loc.addressLines.map((line, idx) => (
                        <div key={idx}>{line}</div>
                      ))}
                    </address>

                    <a
                      className="gmap-link"
                      href={loc.gmap}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="pin">📍</span>
                      <span>Reach Us</span>
                      <span className="underline" />
                    </a>
                  </div>

                  {/* RIGHT SIDE */}
                  <div className="location-right">
                    {loc.contacts.map((c, i) => (
                      <div className="contact-card" key={i}>
                        <div className="avatar-placeholder" aria-hidden="true">
                          👤
                        </div>
                        <div className="contact-right">
                          <div className="contact-title">{c.title}</div>
                          <a
                            className="contact-email"
                            href={`mailto:${c.email}`}
                          >
                            {c.email}
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ContactUs;
